// prettier-ignore
const en = {
    'Sign In': 'Registrarse',
    'Sign Up': 'Regístrate',
    'global.field.empty': 'This field cannot be blank',
    'global.field.invalid': 'Please enter the correct format for this field',

    'create.organization.btn.submit': 'Create',
    'create.organization.msg.required.mailAddress': 'This field cannot be blank',
    //#region System_Msg
    'SYSMSG001': 'A server error occurred. \nPlease contact the administrator.',
    'SYSMSG002': 'Please check your network connection.',
    'SYSMSG003': 'A timeout occurred.',
    //#endregion

    "COMBTN001" : "Cancel",
    "COMBTN002" : "Yes",
    "COMBTN003" : "Apply",
    'COMBTN004' : 'OK',
    "COMBTN006" : "Close",
    'AUTH01MSG10': 'Subdomain does not exist.',

    'COMMSG014': 'This is a required field.',
    'COMMSG034': 'There is no Tag item.',

    'MSG-AI-TOOLTIP-WHEN-OPEN-AI-ON-KNOLEDGE-LIST-PANEL': 'Tooltip when open AI on knowledge list panel',

    // Chat bot
    'CBOTQUOTE01-1': 'AIの回答は正確性を保証するわけではありません。ご留意ください。　',
    'CBOTQUOTE01-2': 'Powered by GPT-4',

    'MSG-AI-ALLOW-ASK-IN-SPOKEN-LANGUAGE': '話し言葉で質問できます',
    "MSG-AI-RESPOND-TO-USER-MSG-ON-PREVIEW-KNOW-ROBO": "Your message has been replied by AI.",
    'MSG-CM-EXCEED-MAX-TEXT-SIZE': 'The total content size exceeds 1MB. Please reduce the content.',
    'MSG-TAG-ITEM-SEARCH-PLACEHOLDER': 'Enter keywords',
    'MSG-TAG-ITEM-SEARCH-ERROR': 'Search failed. Please try again.',
    'ADD_CUSTOMER_PHONE_INVALID': 'The phone number entered is already registered.',

    // AI Settings - Max Knowledge Count
    'TITLE_MAX_AI_CHAT_KNOWLEDGE_COUNT': 'Maximum AI Chat Knowledge Count',
    'LABEL_MAX_AI_CHAT_KNOWLEDGE_COUNT': 'Maximum AI Chat Knowledge Count',
    'MSG-CM-BACK-TO-DEFAULT-MAX-AI-CHAT-KNOWLEDGE-COUNT': 'Reset the maximum AI chat knowledge count to default value. Are you sure?',
    'MSG-AI-INVALID-KNOWLEDGE-BASE-NUMBER': 'Please enter a number between 1 and 1000.',

    // Phone Search V2
    'TAB_HISTORY': 'History',
    'TAB_CONTACTS': 'Contacts',
    'TAB_TRAINING': 'Training',
    'DISPLAY_COUNT': 'Displayed',
    'SEE_MORE': 'See more',
    'RECIPIENT_PROJECT_IN_ORG': 'Projects in Org',
    'RECIPIENT_B2B_CUSTOMER_PROJECT': 'B2B Customer Projects',
    'RECIPIENT_B2B_SUPPORT_PROJECT': 'B2B Support Projects',
    'RECIPIENT_USER_IN_ORG': 'Users in Org',
    'RECIPIENT_PHONE_CALL': 'List phone',

    // Telephone error handling
    'DATA_CHANGED_PLEASE_RELOAD_ERROR': 'Data has been changed. Please reload the page.',
    'TEL_INFO_NO_AVAILABLE_RECEIVER': 'No available users to answer. Call cancelled.',
    'TEL_INFO_CALL_ALREADY_IN_PROGRESS': 'This call is already in progress.',
    'TEL_ERR_TARGET_DELETED': 'This call target has been deleted.',
    'INTERNAL_ERROR': 'An internal error occurred. Please try again.',
    'VOICE_CALL_ERROR': 'Voice call failed. Please try again.',

    'MARKDOWN': 'Markdown'
};

export default en;
